import { TfNotification, useActionNotifications, useDeleteNotifications } from 'api';
import { useTranslations } from 'i18n';
import mixpanel from 'mixpanel-browser';
import * as React from 'react';
import { Button } from 'ui';

interface DismissButtonProps {
    notification: TfNotification;
    children?: string;
    testId?: string;
}
export const DismissButton: React.FC<DismissButtonProps> = ({ children, notification, testId }) => {
    const { __ } = useTranslations();

    const { mutate: deleteNotifications } = useDeleteNotifications();

    function handleClick() {
        deleteNotifications([notification.id]);
        mixpanel.track('BellNotificationDismissClicked', { type: notification.type });
    }

    return (
        <Button
            size="sm"
            color="ghost"
            label={children || __('misc.dismiss')}
            onClick={handleClick}
            disabled={notification.isActioning}
            className="notification-dismiss-button"
            testId={testId}
        />
    );
};

interface ActionButtonProps {
    notification: TfNotification;
    onClick?: () => boolean;
    children?: string;
    variant?: 'primary' | 'ghost' | 'outline' | 'destruct' | undefined;
}

export const ActionButton: React.FC<ActionButtonProps> = ({ children, notification, onClick, variant = 'primary' }) => {
    const { __ } = useTranslations();

    const { mutate: runActions } = useActionNotifications();

    const [isClicked, setIsClicked] = React.useState(false);

    function handleAction() {
        let runDefaultAction = true;
        if (onClick) {
            runDefaultAction = onClick();
        }

        if (runDefaultAction) {
            setIsClicked(true);
            runActions([notification.id]);
        }

        mixpanel.track('BellNotificationActionClicked', { type: notification.type, payload: notification.payload });
    }

    const isLoading = isClicked || notification.isActioning;

    return (
        <Button
            size="sm"
            color={variant}
            label={children || __('misc.update')}
            onClick={handleAction}
            disabled={isLoading}
            isProcessing={isLoading}
            className="notification-action-button"
        />
    );
};
